<template>
  <div class="task-page">
    <empty-data v-if="tableData.length <= 0" emptyMsg="暂无任何任务内容"></empty-data>
    <div class="task-lists" v-else>
      <p class="task-title">我的任务</p>
      <el-table
        class="task-lists__table"
        :data="tableData"
        :row-class-name="tableRowClassName"
        :cell-class-name="tableColClassName"
        :header-row-style="{fontSize: '16px',color: '#333' }"
        :header-cell-class-name="tableColClassName"
        :highlight-current-row="true"
      >
        <el-table-column
          class="el-table-column-test"
          v-for="titleItem in tableTitleInfo"
          :key="titleItem.key"
          :prop="titleItem.prop"
          :label="titleItem.label"
          :align="titleItem.align"
          :width="titleItem.width"
        >
          <template slot-scope="scope">
            <div v-if="titleItem.prop === 'status'" class="live-status row-cont" @click="toTaskDetail(scope.row.id)">
              <p v-if="scope.row.status === 2 || scope.row.status === 3">
                <span>正在直播</span>
                <i></i>
              </p>
              <p v-if="scope.row.status === 1">{{ scope.row.statusTime}}直播</p>
            </div>
            <div v-else-if="titleItem.prop === 'opera'" class="opera-btns row-cont">
              <el-button type="text" size="small" @click="taskNotice(scope.row)">通知</el-button>
              <el-button
                @click="handleOperationTask({type: 'DELETE', taskInfo: scope.row})"
                type="text"
                size="small"
              >删除</el-button>
              <el-button
                @click="handleOperationTask({type: 'EDIT', taskInfo: scope.row})"
                type="text"
                size="small"
              >编辑</el-button>
            </div>
            <p
              class="row-cont"
              v-else-if="titleItem.prop === 'time'"
              @click="toTaskDetail(scope.row.id)"
            >
              {{ scope.row.startTime.replace(/-/g, '/') }} - {{ scope.row.endTime.replace(/-/g, '/')}}
            </p>
            <div class="row-cont" v-else @click="toTaskDetail(scope.row.id)">{{ scope.row[titleItem.prop] }}</div>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <Pages :pageInfo="pageInfo" @handleCurrentChange="handleCurrentChange" />
    </div>
    <create-and-edit-task
      v-if="showEditTaskDialog"
      openType="EDIT"
      :isShowTaskDialog="showEditTaskDialog"
      :themeId="themeId"
      :taskInfo="edidTaskInfo"
      @close="closeTaskAndUpdate"
    ></create-and-edit-task>
    <Notice
      v-if="showCreateNotice"
      :id="noticeTaskId"
      add-type="task"
      :showDialog="showCreateNotice"
      @close="showCreateNotice = false"
    ></Notice>
  </div>
</template>

<script>
import { getMyTaskApi, deleteMyTaskApi } from '@/api/plantform/task';
import { $Cookies, checkUserAuthApi } from "@/utils";
import { Pages, CreateAndEditTask, Notice } from '@/components/plantFormDialogs'
import EmptyData from '../../components/plantFormCommon/empty'
export default {
  name: "myTask",
  components: {
    Pages,
    EmptyData,
    CreateAndEditTask,
    Notice,
  },
  data() {
    return {
      tableData: [],
      tableTitleInfo: [ // 表头配置信息
        { prop: 'themeName', label: '所属主题', width: '250' },
        { prop: 'taskName', label: '任务名称', width: '160' },
        { prop: 'status', label: '', width: '130', key: 'status', align: 'left' },
        { prop: 'realName', label: '负责人', width: '80' },
        { prop: 'time', label: '起始时间', width: '180' },
        { prop: 'opera', label: '操作', width: '' },
      ],
      uid: null,
      themeId: null,
      showEditTaskDialog: false, // 展示 编辑任务弹窗
      edidTaskInfo: {},
      pageInfo: { //分页传参
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      showCreateNotice: false,
      noticeTaskId: 0,
    }
  },

  created() {
    this.uid = $Cookies.get('uid');
    this.getMyTask();
  },
  methods: {
    getMyTask() {
      const params = {
        uid: this.uid,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      }
      getMyTaskApi(params).then(data => {
        if (data.success) {
          const { list, total, pageNum } = data.result;
          this.pageInfo.total = total;
          this.pageInfo.pageNum = pageNum;
          this.tableData = list;
        } else {
          this.$message.error(data.errorMsg);
        }
      })
    },

    // 编辑、删除任务
    async handleOperationTask(options) {
      const { type, taskInfo } = options
      this.themeId = taskInfo.themeId

      const typePer = type === 'EDIT' ? 'editTask' : 'deleteTask';
      const hasPermissions = await checkUserAuthApi(typePer, taskInfo.themeId, taskInfo.id)

      if (!hasPermissions) return false

      if (type === 'EDIT') {
        this.edidTaskInfo = taskInfo
        this.showEditTaskDialog = true
      } else {
        this.$confirm('此操作将永久删除该任务, 是否继续?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const params = {
            uid: this.uid,
            taskId: taskInfo.id
          }
          deleteMyTaskApi(params).then(data => {
            if (data.success && data.result.status === 'SUCCESS') {
              this.$message({
                message: '删除任务成功',
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.getMyTask();
                }
              });
            } else {
              this.$message.error(data.errorMsg);
            }
          })
        }).catch(() => {
          return false;
        });
      }
    },

    // 跳转至任务详情页
    toTaskDetail(id) {
      this.$router.push('/plantForm/taskDetail/' + id)
    },

    // 表格行样式
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'table-list__row row-has_bgc' : 'table-list__row'
    },

    // 表格列样式
    tableColClassName({ columnIndex }) {
      return columnIndex === 0 ? 'pl20' : ''
    },

    // 翻页
    handleCurrentChange(val) {
      this.pageInfo.pageNum = val;
      this.getMyTask();
    },

    // 关闭 任务编辑 弹窗
    closeTaskAndUpdate(result) {
      this.showEditTaskDialog = false
      this.themeId = null
      if (!result) return
      this.pageInfo = {
        pageNum: 1,
        total: 0,
        pageSize: 10
      }
      this.getMyTask()
    },
    async taskNotice(info) {
      const { themeId, id } = info
      const hasPermissions = await checkUserAuthApi('taskNotice', themeId, id)
      if (!hasPermissions) return false

      this.noticeTaskId = info.id
      this.showCreateNotice = true

    }
  }
}
</script>

<style lang="scss" scoped>
.task-page {
  .task-lists {
    .task_lists_pagination {
      text-align: right;
      margin-top: 30px;
    }
  }
}
</style>
